import * as signalR from "@microsoft/signalr";
import { RefObject, useEffect, useRef, useState } from "react";

interface DroneHubHook {
    connection: signalR.HubConnection;
    protocol: RefObject<signalR.JsonHubProtocol>;
    start: () => void;
    stop: () => void;
}

function useDroneHubConnection(): DroneHubHook {
    const protocol = useRef<signalR.JsonHubProtocol>(new signalR.JsonHubProtocol());
    const [connection] = useState<signalR.HubConnection>(hubConnect);

    useEffect(() => {
        return () => {
            console.log("useDroneHubConnection cleaned up")
            connection.stop();
        };
    }, [connection]);

    function hubConnect(): signalR.HubConnection {
        // Адрес абсолютный: на вложенных роутах (/statistics/modem) относительный ушёл бы мимо /api.
        // Токен хабу не передаём: куку hawk.sid браузер сам цепляет и к negotiate, и к WebSocket-рукопожатию.
        const connection = new signalR.HubConnectionBuilder()
            .withUrl("/api/drone-hub")
            .withAutomaticReconnect([0, 2000, 10000, 10000, 30000, 10000])
            .withHubProtocol(protocol.current)
            .build();

        connection.start();

        console.log("DroneHub connection started");

        return connection;
    }

    function start() {
        connection.start();
    }

    function stop() {
        connection.stop();
    }

    return {
        protocol,
        connection,
        start,
        stop
    };
}

export default useDroneHubConnection;